import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button, Menu, MenuItem, Stack } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import * as IdentityHelper from '../../api/identity/identityHelper';
import Span from '../../shared/component/Span';
import variable from '../../shared/variable';
import { useAppSelector } from '../../store/hook';
import { selectUser } from '../../store/user/userSlice';
import { EStatusCode } from '../../api/enum';

interface IProfileProps {}

const Profile = (props: IProfileProps) => {
    const { t } = useTranslation();

    const user = useAppSelector(selectUser);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {
        let res = await IdentityHelper.logoutAsync();
        if (res.status == EStatusCode.Ok) {
            window.location.href = variable.URL_EDESIGN_PORTAL;
        }
    };

    return (
        <Stack>
            <Button
                variant='greenLight'
                startIcon={<AccountCircleIcon />}
                id='profile-button'
                endIcon={<KeyboardArrowDownIcon />}
                aria-controls={open ? 'profile-menu' : undefined}
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <Span text={user.data?.firstName + ' ' + user.data?.lastName} />
            </Button>
            <Menu
                id='profile-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'profile-button',
                }}>
                <MenuItem onClick={handleLogout}>{t('logout')}</MenuItem>
            </Menu>
        </Stack>
    );
};

export default Profile;
